import { Link } from "react-router-dom";
import { IDS } from "@/lib/testIds";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={IDS.footer.root}
      style={{
        background: "var(--surface-sunken)",
        borderTop: "1px solid var(--separator)",
        marginTop: 96,
        position: "relative",
        zIndex: 5,
      }}
    >
      <div className="container-cs" style={{ padding: "64px 0 40px", display: "grid", gap: 40, gridTemplateColumns: "1fr", }}>
        <div style={{ display: "grid", gap: 24, gridTemplateColumns: "minmax(0, 1fr) auto", alignItems: "end" }}>
          <div>
            <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 12, textDecoration: "none", color: "var(--ink-primary)", minHeight: 0 }}>
              <img src="/icon.png" alt="Countersign app icon" width="36" height="36" style={{ width: 36, height: 36, borderRadius: 8, display: "block" }} />
              <span className="font-display" style={{ fontFamily: "var(--font-display)", fontSize: 22, fontWeight: 600 }}>Countersign</span>
            </Link>
            <p style={{ maxWidth: "42ch", marginTop: 18, color: "var(--ink-secondary)" }}>
              A scam-check app for families. Because a word only your family knows is the one thing an AI cannot clone.
            </p>
          </div>
          <nav aria-label="Footer" style={{ display: "flex", gap: 22, flexWrap: "wrap" }}>
            <Link to="/privacy" data-testid={IDS.footer.privacy} style={{ color: "var(--ink-primary)" }}>Privacy</Link>
            <Link to="/support" data-testid={IDS.footer.support} style={{ color: "var(--ink-primary)" }}>Support</Link>
            <Link to="/accessibility" data-testid={IDS.footer.accessibility} style={{ color: "var(--ink-primary)" }}>Accessibility</Link>
          </nav>
        </div>
        <hr className="hr-warm" />
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "space-between", color: "var(--ink-tertiary)", fontSize: 15 }}>
          <span>© {year} Countersign. Made with care in Canada.</span>
          <span>countersign.ca</span>
        </div>
      </div>
    </footer>
  );
}
